import type { Template } from "@/types";

export const LA_02_H1_V1: Template[] = [
{
    id: "la-02-h1v1-01",
    name: "LA 01 - H1V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 37, y: 64, width: 564, height: 351, rotation: 0, imageRotation: 0 },
            { id: "2", x: 830, y: 64, width: 251, height: 351, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h1v1-02",
    name: "LA 02 - H1V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 67, y: 89, width: 502, height: 300, rotation: 0, imageRotation: 0 },
            { id: "2", x: 802, y: 34, width: 308, height: 410, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h1v1-03",
    name: "LA 03 - H1V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 28, y: 30, width: 580, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 928, y: 30, width: 314, height: 418, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h1v1-04",
    name: "LA 04 - H1V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 676, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 818, y: 0, width: 370, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h1v1-05",
    name: "LA 05 - H1V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 177, y: 42, width: 283, height: 393, rotation: 0, imageRotation: 0 },
            { id: "2", x: 673, y: 42, width: 564, height: 393, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h1v1-06",
    name: "LA 06 - H1V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 177, y: 42, width: 283, height: 393, rotation: 0, imageRotation: 0 },
            { id: "2", x: 638, y: 0, width: 637, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h1v1-07",
    name: "LA 07 - H1V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 172, y: 51, width: 305, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 485, y: 51, width: 617, height: 374, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h1v1-08",
    name: "LA 08 - H1V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 740, y: 89, width: 433, height: 300, rotation: 0, imageRotation: 0 },
            { id: "2", x: 208, y: 89, width: 221, height: 300, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h1v1-09",
    name: "LA 09 - H1V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h1_v1_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 32, y: 30, width: 302, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 665, y: 30, width: 580, height: 418, rotation: 0, imageRotation: 0 }
    ],
}
];